import OwnerTreeList from "containers/owner/OwnerTreeList";
import { Modal } from "react-bootstrap";
import React from "react";
import { createElementIdFactory } from "utils/elementIds";

function OwnerTreeModal({
    data = [],
    updateTableState,
    saveRecord,
    parentChild,
    propertyidlist,
    idList,
    show,
    onClose,
}) {
    const createId = createElementIdFactory("owner-tree-modal");

    return (
        <Modal id={createId("modal")} show={show} onHide={onClose} size="xl" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Tree</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <div>Use the Owner Search in tabs of the owner screen to search and add parent companies.</div>
                <OwnerTreeList
                    controlType="table"
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    parentChild={parentChild}
                    propertyidlist={propertyidlist}
                    idList={idList}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerTreeModal;